import {useEffect, useState} from 'react';
import {ROWS_PER_PAGE} from './TenantPager';
import {sortInfoFor} from './phoneSortOptions';

export const PHONE_PAGE_SIZE = ROWS_PER_PAGE[0];

const usePhoneTenantPage = ({
  fetchData,
  onFetchError,
  onRowsLoaded,
  query,
  status,
  allSorting,
  sortKey,
  refreshKey
}) => {
  const filterKey = `${query}|${status}|${allSorting}|${sortKey}`;
  const [pageState, setPageState] = useState({filterKey, skip: 0});
  const [page, setPage] = useState({rows: null, total: 0});
  if (pageState.filterKey !== filterKey) {
    setPageState({filterKey, skip: 0});
  }
  const skip = pageState.filterKey === filterKey ? pageState.skip : 0;

  useEffect(() => {
    let ignore = false;
    const load = async () => {
      try {
        const result = await fetchData({
          skip,
          limit: PHONE_PAGE_SIZE,
          sortInfo: sortInfoFor(sortKey)
        });
        if (ignore || result.stale) return;
        if (result.data.length === 0 && skip > 0) {
          setPageState({filterKey, skip: Math.max(0, skip - PHONE_PAGE_SIZE)});
          return;
        }
        setPage({rows: result.data, total: result.count});
        onRowsLoaded(result.data);
      } catch (error) {
        if (ignore) return;
        onFetchError(error);
      }
    };
    load();
    return () => {
      ignore = true;
    };
  }, [
    fetchData,
    onFetchError,
    onRowsLoaded,
    skip,
    sortKey,
    filterKey,
    refreshKey
  ]);

  const goToSkip = nextSkip => setPageState({filterKey, skip: nextSkip});

  return {
    rows: page.rows,
    total: page.total,
    skip,
    limit: PHONE_PAGE_SIZE,
    goPrevious: () => goToSkip(Math.max(0, skip - PHONE_PAGE_SIZE)),
    goNext: () => goToSkip(skip + PHONE_PAGE_SIZE)
  };
};

export default usePhoneTenantPage;
